import apiClient from '../clients/apiClient';
import { ApiResponse } from '../schemas/apiResponseSchema';
import { Schemas } from '../types/api-types';

export type SystemPermissionResponse = Schemas['SystemPermissionResponse'];

export async function getSystemPermissions(): Promise<SystemPermissionResponse[]> {
    try {
        const response: ApiResponse<SystemPermissionResponse[]> = (
            await apiClient.get('/system_permissions/all')
        ).data;
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.detail || 'Fetching system permissions failed');
        }
        throw new Error('network error, please contact support team');
    }
}